import http from '../http/http';

import {
    generateEndpoint,
    DOCUMENTS,
    ONE_DOCUMENT,
    DOCUMENT_BY_VARIANT,
    DOCUMENT_BY_VARIANT_WITH_TOKEN,
    DOCUMENT_LABELS,
    DOCUMENTS_INCLUDE_IN_REPORT,
} from '../http/endpoints';

export default (() => {
    const getDocumentByVariant = (documentId, variant) =>
        http.get(
            generateEndpoint(DOCUMENT_BY_VARIANT, { documentId, variant })
        );

    const getDocumentByVariantWithToken = (documentId, variant, token) =>
        http.get(
            generateEndpoint(DOCUMENT_BY_VARIANT_WITH_TOKEN, {
                documentId,
                variant,
                token,
            })
        );

    const deleteDocument = (id) =>
        http.delete(generateEndpoint(ONE_DOCUMENT, { id }));

    const create = (params) => http.post(generateEndpoint(DOCUMENTS), params);
    const updateIncludeInReport = (params, defectId) =>
        http.put(
            generateEndpoint(DOCUMENTS_INCLUDE_IN_REPORT, { defectId }),
            params
        );

    const getAllLabels = () => http.get(generateEndpoint(DOCUMENT_LABELS));

    return {
        getDocumentByVariant,
        getDocumentByVariantWithToken,
        delete: deleteDocument,
        create,
        updateIncludeInReport,
        getAllLabels,
    };
})();
